/* eslint-disable react/no-danger */
import React, { CSSProperties, ReactNode } from 'react'
import classnames from 'classnames'
import Link from 'components/Link'
import Button, { Props as ButtonProps } from 'components/UI/Button'
import { useMobile } from 'hooks/ua'

import styles from './style.less'

export type Banner = {
  title: string
  desc: string
  pcImg: string
  mobileImg: string
  pcHeight?: number
  mobileHeight?: number
  /** 主题是否为深色，优先级高于背景色判断逻辑 */
  // 后续将重新制定更规范的逻辑，从而根据 banner 图自动判断是否为深色主题，而不再需要这个字段
  dark?: boolean
  /** 背景色，用于判断是否为暗色（仅当 dark 不为 true 时才会生效）以及提供 button text color */
  backgroundColor?: string
  href: string | null
  btns?: ButtonProps[]
  extra?: ReactNode
}

export default function PageBanner(banner: Banner) {
  const {
    dark, title, desc, href, pcImg, mobileImg, btns,
    backgroundColor = '#f4f4ff',
    pcHeight = 560,
    mobileHeight = 340,
    extra
  } = banner
  const isMobile = useMobile()
  const bgImg = isMobile ? mobileImg : pcImg

  function renderExtra() {
    if (isMobile) {
      return null
    }

    if (!btns?.length) return extra

    return (
      <div className={styles.btnsWrapper}>
        {
          btns.map((btn, index) => (
            index === 0
              ? <Button key={index} type="primary" className={styles.btn} {...btn} />
              : <Button key={index} type="hollow" className={classnames(styles.btn, styles.hollow)} withBorder {...btn} />
          ))
        }
      </div>
    )
  }
  const bgColorStyle = { backgroundColor }

  const bgStyle: CSSProperties = {
    backgroundImage: `url(${bgImg})`
  }

  if (isMobile) {
    bgStyle.minHeight = mobileHeight
  } else {
    bgStyle.height = pcHeight
  }

  function withWrapper(children: ReactNode) {
    const props = {
      className: classnames(styles.mainWrapper, styles.index),
      style: bgColorStyle,
      children
    }
    if (href == null) {
      return <div {...props} />
    }
    return <Link {...props} href={href} />
  }

  return withWrapper(
    <div className={styles.contentWrapper} style={bgStyle}>
      <div className={classnames(styles.content, dark && styles.dark)}>
        {title && <h1 className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />}
        {desc && <p className={styles.desc} dangerouslySetInnerHTML={{ __html: desc }} />}
        {renderExtra()}
      </div>
    </div>
  )
}
